import type { Meta, StoryObj } from "@storybook/react";

import { HeaderDecorator } from "@/__stories__/Decorator";
import type { ModalFooterProps } from "@/ui/composed/modal/ModalFooter";
import ModalFooter, {
  LeftButtonTypeValues,
} from "@/ui/composed/modal/ModalFooter";
import { FAIconName } from "@/ui/core";

const StoryMeta: Meta<ModalFooterProps> = {
  title: "Components/Modal/Footer",
  component: ModalFooter,
  argTypes: {
    isLoading: { control: "boolean" },
    isRightButtonDisabled: { control: "boolean" },
    leftButtonType: {
      control: "select",
      options: Object.values(LeftButtonTypeValues),
    },
    onLeftButtonPress: { action: "left button pressed" },
    onRightButtonPress: { action: "primary button pressed" },
    rightButtonLabel: { control: "text" },
    rightButtonLeftIcon: {
      control: "select",
      options: Object.values(FAIconName),
    },
    rightButtonRightIcon: {
      control: "select",
      options: Object.values(FAIconName),
    },
  },
  args: {
    isLoading: false,
    isRightButtonDisabled: false,
    rightButtonLabel: "Continue",
    rightButtonRightIcon: FAIconName.ArrowRight,
  },
  decorators: [(story) => <HeaderDecorator>{story()}</HeaderDecorator>],
};

type Story = StoryObj<ModalFooterProps>;

const Primary: Story = {};
const Disabled: Story = {
  args: {
    isRightButtonDisabled: true,
  },
};

const WithCancel: Story = {
  args: {
    leftButtonType: LeftButtonTypeValues.cancel,
  },
};

const Loading: Story = {
  args: {
    isLoading: true,
  },
};

const WithLeftButtonHidden: Story = {
  args: {
    isLeftButtonHidden: true,
  },
};

export { Disabled, Loading, Primary, WithCancel, WithLeftButtonHidden };

export default StoryMeta;
